function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.41 18.59c-.4 0-.73-.33-.73-.73 0-.4.33-.73.73-.73 2.82 0 5.12-2.3 5.12-5.12 0-2.82-2.3-5.12-5.12-5.12a5.13 5.13 0 00-5.12 5.12c0 .4-.33.73-.73.73-.4 0-.73-.33-.73-.73 0-3.63 2.95-6.59 6.59-6.59C19.06 5.42 22 8.37 22 12s-2.95 6.59-6.59 6.59z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 12a6.59 6.59 0 01-6.59 6.59c-1.25 0-2.42-.35-3.41-.96A6.57 6.57 0 0015.17 12 6.57 6.57 0 0012 6.37c1-.6 2.17-.96 3.41-.96A6.59 6.59 0 0122 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.59 5.41c.4 0 .73.33.73.73 0 .4-.33.73-.73.73a5.13 5.13 0 00-5.12 5.12c0 2.82 2.3 5.12 5.12 5.12 2.82 0 5.12-2.3 5.12-5.12 0-.4.33-.73.73-.73.4 0 .73.33.73.73 0 3.63-2.95 6.59-6.59 6.59C4.94 18.58 2 15.63 2 12s2.95-6.59 6.59-6.59z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M15.17 12A6.57 6.57 0 0112 17.63c-1 .6-2.17.96-3.41.96A6.59 6.59 0 012 12a6.59 6.59 0 016.59-6.59c1.24 0 2.41.36 3.41.96A6.57 6.57 0 0115.17 12z"
})));